import { instagramApi } from '@jarvis.oddle/core/api/instagram/client'
import { origin, IG_API_ROOT } from 'config/client'

export const {
  getIgUserMediaApi
} = instagramApi({ origin, igApiRoot: IG_API_ROOT })
